import { render } from "./RightGates.vue?vue&type=template&id=4194c498"
import script from "./RightGates.vue?vue&type=script&lang=js"
export * from "./RightGates.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__